export function deleteMapElementById(setMapElements, id) {
  setMapElements((prevMapElements) =>
    prevMapElements.filter((element) => element.id !== id)
  );
}
